export default __webpack_public_path__ + "static/media/clock.d80afdb3.svg";